<template>
  <div class="pt-0 pl-5 pr-5 pb-5">
    <b-row class="d-flex text-light py-sm-3 px-lg-5 header-container m-auto">
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex flex-wrap justify-content-start align-items-center w-75">
          <p class="h4 font-weight-bolder text-left text-capitalize m-0 mr-3">Hi, {{ userName }}</p>
          <div class="d-flex justify-content-star align-items-center mr-auto">
            <b-button
              class=" bg-green-btn rounded-pill text-capitalize py-1 mr-2"
              @click="$router.push('ranking')"
              disabled
            >
              <b-img
                v-if="levelInfo.image"
                fluid
                :src="levelInfo.image"
                alt="Badge icon"
                width="20px"
              ></b-img>
              <span class="small">
                {{ levelInfo.name }}
              </span>
            </b-button>
            <p class="m-0">{{ levelInfo.childPoints }} pts</p>
          </div>
        </div>
        <div class=" d-flex flex-row">
          <div class="avatarIconContainerChild">
            <img
              :src="childAvatar ? childAvatar : require(`@/assets/avatar.png`)"
              alt="Avatar icon"
            />
            <div class="bg-coin d-flex justify-content-center align-items-center bg-coin-absolute">
              <p class="h1 font-weight-bolder mb-3" :class="coinsStringLength <= 4 ? 'ph1' : 'ph2'">
                {{ coinsInfo.banked }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="h6 w-75 mt-3">
        <motivational-message />
      </p>
    </b-row>
  </div>
</template>

<script>
import { MotivationalMessage } from '@/common/components';

export default {
  props: {
    userName: { type: String, required: true },
    levelInfo: { type: Object, required: true },
    coinsInfo: { type: Object, required: true },
    childInfo: { type: Object, required: true },
  },
  components: { MotivationalMessage },
  computed: {
    childAvatar() {
      if (this.childInfo) {
        return this.childInfo.avatar;
      }
      return null;
    },
    coinsStringLength() {
      if (this.coinsInfo.banked) {
        return this.coinsInfo.banked.toString().length;
      }
      return 0;
    },
  },
};
</script>
<style lang="scss">
.p-6 {
  padding: 3rem 3rem 7rem 3rem;

  @media (max-width: 700px) {
    padding: 3rem 1.5rem 7rem 1.5rem;
  }
}
.header-container {
  padding-bottom: 103px !important;
  padding: 0 20px;
  align-items: center;
}
.bg-badge-small {
  height: 25px;
  width: 25px;
}
.width-139 {
  width: 139px;
}

.sentence {
  width: 393px;
  padding-left: 18px;
  margin-top: -46px;
}
.width-name {
  width: 200px;
}

.childInfo {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.avatarIconContainerChild {
  background-color: white;
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 100%;
  }
}

.avatarIconContainerParent {
  background-color: white;
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  left: 0;
  z-index: 2;
  & > img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 100%;
  }
}
.childSelector {
  background-color: #43a5ab;
  position: relative;
  padding-left: 5rem;
  border-radius: 99999px;
  box-shadow: inset -4px 4px 10px rgba(0, 0, 0, 0.25);

  .dropdown-toggle {
    border-radius: 50px;
    background-color: transparent;
    border-radius: 99999px;
    border: none;
  }
}

.bg-coin-absolute {
  position: absolute;
  width: 65%;
  top: 65%;
  left: 65%;
}

.notificationButton {
  width: 24px;
  height: 24px;
  padding: 1.2rem;
  display: flex;
}

.levelPoints {
  text-align: center;
}

@media (max-width: 992px) {
  .notificationButton {
    display: none;
  }
}
@media (max-width: 992px) {
  .sentence {
    margin-top: 235px;
  }
}

@media (min-width: 200px) and (max-width: 500px) {
  .header-container {
    border-radius: 1.2rem 1.2rem 0 0 !important;
  }
  .sentence {
    margin-top: 25px;
  }

  .levelPoints {
    text-align: right;
  }
}

@media (min-width: 501px) and (max-width: 992px) {
  .header-container {
    border-radius: 1.2rem 1.2rem 0 0 !important;
  }

  .sentence {
    margin-top: -56px;
  }
}
</style>

